// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let PropertiesPageRelayRefetchQuery_graphql = require("./PropertiesPageRelayRefetchQuery_graphql.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"searchForSaleProperties_edges_node":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

let Utils = {};

function makeNode(rescript_graphql_node_PropertiesPageRelayRefetchQuery) {
  return ({
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "areaIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "before"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "forSalePropertyTypes"
    },
    {
      "kind": "RootArgument",
      "name": "forSaleStatuses"
    },
    {
      "kind": "RootArgument",
      "name": "keywords"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "last"
    },
    {
      "kind": "RootArgument",
      "name": "maxBeds"
    },
    {
      "kind": "RootArgument",
      "name": "maxPrice"
    },
    {
      "kind": "RootArgument",
      "name": "minBeds"
    },
    {
      "kind": "RootArgument",
      "name": "minPrice"
    },
    {
      "kind": "RootArgument",
      "name": "offMlsOnly"
    },
    {
      "kind": "RootArgument",
      "name": "sortOrder"
    },
    {
      "kind": "RootArgument",
      "name": "useForSaleProperties"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": rescript_graphql_node_PropertiesPageRelayRefetchQuery
    }
  },
  "name": "PropertiesPageRelayForSale_query",
  "selections": [
    {
      "condition": "useForSaleProperties",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "after",
              "variableName": "after"
            },
            {
              "kind": "Variable",
              "name": "areaIds",
              "variableName": "areaIds"
            },
            {
              "kind": "Variable",
              "name": "before",
              "variableName": "before"
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "first"
            },
            {
              "kind": "Variable",
              "name": "keywords",
              "variableName": "keywords"
            },
            {
              "kind": "Variable",
              "name": "last",
              "variableName": "last"
            },
            {
              "kind": "Variable",
              "name": "maxBeds",
              "variableName": "maxBeds"
            },
            {
              "kind": "Variable",
              "name": "maxPrice",
              "variableName": "maxPrice"
            },
            {
              "kind": "Variable",
              "name": "minBeds",
              "variableName": "minBeds"
            },
            {
              "kind": "Variable",
              "name": "minPrice",
              "variableName": "minPrice"
            },
            {
              "kind": "Variable",
              "name": "offMlsOnly",
              "variableName": "offMlsOnly"
            },
            {
              "kind": "Variable",
              "name": "propertyTypes",
              "variableName": "forSalePropertyTypes"
            },
            {
              "kind": "Variable",
              "name": "sortOrder",
              "variableName": "sortOrder"
            },
            {
              "kind": "Variable",
              "name": "statuses",
              "variableName": "forSaleStatuses"
            }
          ],
          "concreteType": "ForSalePropertyV5Connection",
          "kind": "LinkedField",
          "name": "searchForSaleProperties",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ForSalePropertyV5Edge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ForSalePropertyV5",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ForSalePropertySearchResult_forSalePropertyV5"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
});
}

let node = makeNode(PropertiesPageRelayRefetchQuery_graphql.node);

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
